export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00570.1d95525c.png";